import { CurrentUserModel } from './current-user-model';

export class RootStore {
  currentUserStore: CurrentUserModel;

  constructor() {
    this.currentUserStore = new CurrentUserModel();
  }
}
